import * as THREE from "three";

// ── Texture Setup ─────────────────────────────────────────────────────────────

const loader = new THREE.TextureLoader();
const ropeTexture = loader.load("/textures/rope_texture.jpg");

ropeTexture.wrapS = THREE.RepeatWrapping;
ropeTexture.wrapT = THREE.RepeatWrapping;
ropeTexture.anisotropy = 16;
ropeTexture.repeat.set(50, 25);

// ── Helper Functions ──────────────────────────────────────────────────────────

function slideRope(parts, name, speed) {
    const group = parts[name];
    if (!group) return;
    group.traverse(child => {
        if (child.isMesh) {
            if (child.material.map !== ropeTexture) {
                child.material.map = ropeTexture;
                child.material.needsUpdate = true;
            }
            child.material.map.offset.y += -speed;
        }
    });
}

function rotate(parts, name, axis, speed) {
    if (!parts[name]) return;
    parts[name].rotation[axis] += speed;
}

// ── Per-movement persistent state store ───────────────────────────────────────
const _store = new Map();
function getStore(id) {
    if (!_store.has(id)) _store.set(id, {});
    return _store.get(id);
}
function resetStore(id) {
    _store.set(id, {});
}

function applyRopeTexture(parts, name, store) {
    if (store.ropeTextureReady) return;
    const rope = parts[name];
    if (!rope) return;
    rope.traverse(child => {
        if (child.isMesh) {
            child.material = child.material.clone();
            child.material.map = ropeTexture;
            child.material.roughness = 0.9;
            child.material.metalness = 0.55;
            child.material.needsUpdate = true;
        }
    });
    store.ropeTextureReady = true;
}

// ── Movement Registry ─────────────────────────────────────────────────────────

export { resetStore };
export const MovementRegistry = {

    "m1": (parts, delta, state) => {
        const speed = 0.5;
        rotate(parts, "driving_pulley", "y", delta * speed);
        rotate(parts, "driven_pulley", "y", delta * speed);
        slideRope(parts, "rope", delta * speed * 1.0);
    },

    "m2": (parts, delta, state) => {
        const speed = 0.5;
        rotate(parts, "driving_pulley", "z", delta * speed);
        rotate(parts, "driven_pulley", "z", delta * -speed);
        slideRope(parts, "rope", delta * speed * 1.0);
    },

    "m3": (parts, delta, state) => {
        const speed = 0.5;
        rotate(parts, "driving_pulley", "z", delta * speed);
        rotate(parts, "small_driven_pulley_nr_1", "z", delta * speed);
        rotate(parts, "small_driven_pulley_nr_2", "z", delta * -speed);
        rotate(parts, "shaft", "z", delta * speed);
        slideRope(parts, "rope", delta * speed * -1.0);
    },

    "m4": (parts, delta, state) => {
        const speed = 0.5;
        rotate(parts, "driving_pulley_wide", "z", delta * -speed);
        rotate(parts, "small_driven_pulley_nr_1", "z", delta * speed);
        rotate(parts, "small_driven_pulley_nr_2", "z", delta * speed);
        rotate(parts, "small_driven_pulley_wide", "z", delta * -speed);
        rotate(parts, "shaft_small_pulley", "z", delta * speed);
        slideRope(parts, "rope", delta * speed * -1.0);
    },

    "m5": (parts, delta, state) => {
        const speed = 0.5;

        // ── TEXTURE SETUP (one-time, so rope isn't naked) ─────────────────────
        const store = getStore("m5");
        applyRopeTexture(parts, "rope", store);

        rotate(parts, "driven_pulley", "z", delta * -speed);

        // ── CONTACT GATE ──────────────────────────────────────────────────────
        const tensioner = parts["smaller_driven_pulley"];
        if (!tensioner || tensioner.position.x <= 0.1) return;

        // ── GATED ROTATION & SCROLL ───────────────────────────────────────────
        rotate(parts, "big_driven_pulley", "z", delta * -speed);
        rotate(parts, "smaller_driven_pulley", "z", delta * speed);
        slideRope(parts, "rope", delta * speed * -1.0);
    },
};